export const TITLE = 'Form Description';
export const PLACEHOLDER = 'This is the description for General Biology';
